
import axios from 'axios';
import React, { createContext, useContext, useState } from 'react'
import BaseURL from '../Utilities/BaseUrl';
import notify from '../Utilities/Notify';

 export const cartContext=createContext();

export default function CartContextProvider({children}) {

    const [count, setcount] = useState(0)
    const [loading, setloading] = useState(false);
  const [disable, setdisable] = useState(false);
  const [productsCart, setproductsCart] = useState([]);
  const [totalPrice, settotalPrice] = useState(0);
  const [check, setcheck] = useState(false);

  
   function setProductInCart(productId) {
    setloading(true);
    setdisable(true);
    let token=localStorage.getItem('token');
    if(token!=null)
    {
    let headers={
        token
       };
    let body={
        productId
    }
    axios.post(`${BaseURL}cart`,body,{headers}).then((response)=>{
 
        
        if(response.status==200)
        {
         
            notify('success',response.data.message)
            setloading(false);
            setdisable(false);
            localStorage.setItem('cartNum',response.data.numOfCartItems);
        }

    }).catch((error)=>{

       return error;
    })
    }
    else{
        notify('error','Please Login Firstly if not have account create account')
    }
   }
   function updateCountInCart(productId,count) {
    setloading(true);
    setdisable(true);
    let token=localStorage.getItem('token');
    if(token!=null)
    {
    let headers={
        token
       };
   let body={
    count
   }
    axios.put(`${BaseURL}cart/${productId}`,body,{headers}).then((data)=>{
 
        
        if(data.status==200)
        {
           
           setproductsCart(data.data.data.products)
           if( count >= 0){
            
               
            notify('success','Update Count Success')}
            else{
                
                notify('warning','Not Allow  Less Than 0')
            }
            
            setloading(false);
            setdisable(false);
        }

    }).catch((error)=>{
        
   
    })
    }
    else{
        notify('error','Please Login Firstly if not have account create account')
    }
   }
   function getCart() {
    let token=localStorage.getItem('token');
    let headers={
        token
       };
    if(token!=null)
    {
    axios.get(`${BaseURL}cart`,{headers}).then((data)=>{ 
        if (
            data.status==200 ) {
               
                setproductsCart(data.data.data.products)
                settotalPrice(data.data.data.totalCartPrice);
                localStorage.setItem('cartNum',data.data.numOfCartItems);
                localStorage.setItem('cartID',data.data.data._id);
                 setcheck(true)
        }
           
     }).catch((error)=>{ 

       
setproductsCart([])  

    })}
   }
 

  return <cartContext.Provider value={{setProductInCart,loading,disable,setdisable,setloading,getCart,productsCart,totalPrice,updateCountInCart,check,setcheck}} >

      {children}

  </cartContext.Provider>
  
  
  
}
